export const MAX_OLD_CONVERSATION_DAYS = 660;

export const SAVED_REPLY_TITLE_MAX_LENGTH = 80;
export const SAVED_REPLY_MESSAGE_MAX_LENGTH = 2000;

export default {
  MAX_OLD_CONVERSATION_DAYS,
  SAVED_REPLY_TITLE_MAX_LENGTH,
  SAVED_REPLY_MESSAGE_MAX_LENGTH,
};
